// extracted by mini-css-extract-plugin
module.exports = {"unassigned":"AssignedDriver-module__unassigned--29ncA"};